// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"394213c1","244":"a1b4c2f2","346":"faeb7f92","416":"fc5612f0","439":"5280d5db","534":"2db706c5","634":"d2d1da7a","727":"d92e9564","885":"faeb7f92","965":"faeb7f92"}[chunkId] + ".chunk.css";
};